export default {
    //话题列表
    getTopics (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/topics', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //获取频道信息
    getChannelInfo (id) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/' + id + '/channel')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //问答列表
    getList (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/lists', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //问答详情
    getShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/' + id, {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //答案详情
    getAnswerShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/' + id + '/answer', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //有帮助
    setPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //无帮助
    setNoPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/praise-no',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //答案采纳
    setAdopt(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/adopt',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论点赞
    setCommentPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/comment/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //问答评论
    getCommentList (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/' + id + '/comments',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论详情
    getCommentShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask-comment/' + id,{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论回复详情
    getCommentReplys (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask-comment/' + id + '/replys',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论/回复
    Comment (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/comment',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //收藏
    Collect(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/ask/collect',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论删除
    delComment(id){
        return new Promise((resolve, reject) => {
            axios.delete('/api/ask-comment/'+id+'/delete')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getLabels(params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/labels',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getChannel(id) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/'+id+'/channel')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getAnswerList(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/space-answers', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
}